import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/awtinvestments/public_html/app/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/awtinvestments/public_html/app/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/awtinvestments/public_html/app/components/scrolltoTop.tsx");
;
import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/awtinvestments/public_html/languageprovider.tsx");
;
import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/awtinvestments/public_html/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"variable\":\"--font-poppins\",\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
